import React from 'react';
import { Image } from 'antd';

import preview1 from '../../assets/ieskatam_1.jpg';
import preview2 from '../../assets/ieskatam_2.jpg';
import preview3 from '../../assets/ieskatam_3.jpg';
import preview4 from '../../assets/ieskatam_4.jpg';
import preview5 from '../../assets/ieskatam_5.jpg';
import preview6 from '../../assets/ieskatam_6.jpg';
import preview7 from '../../assets/ieskatam_7.jpg';
import preview8 from '../../assets/ieskatam_8.jpg';
import preview9 from '../../assets/ieskatam_9.jpg';
import preview10 from '../../assets/ieskatam_10.jpg';
import preview11 from '../../assets/ieskatam_11.jpg';
import preview12 from '../../assets/ieskatam_12.jpg';
import preview13 from '../../assets/ieskatam_13.jpg';
import preview14 from '../../assets/ieskatam_14.jpg';
import preview15 from '../../assets/ieskatam_15.jpg';
import preview16 from '../../assets/ieskatam_16.jpg';
import preview17 from '../../assets/ieskatam_17.jpg';
import preview18 from '../../assets/ieskatam_18.jpg';
import preview19 from '../../assets/ieskatam_19.jpg';
import preview20 from '../../assets/ieskatam_20.jpg';
import preview21 from '../../assets/ieskatam_21.jpg';
import preview22 from '../../assets/ieskatam_22.jpg';
import preview24 from '../../assets/ieskatam_24.jpg';
import preview25 from '../../assets/ieskatam_25.jpg';
import preview26 from '../../assets/ieskatam_26.jpg';
import preview27 from '../../assets/ieskatam_27.jpg';
import preview28 from '../../assets/ieskatam_28.jpg';
import preview29 from '../../assets/ieskatam_29.jpg';
import preview30 from '../../assets/ieskatam_30.jpg';
import preview31 from '../../assets/ieskatam_31.jpg';
import preview32 from '../../assets/ieskatam_32.jpg';
import preview33 from '../../assets/ieskatam_33.jpg';
import preview34 from '../../assets/ieskatam_34.jpg';
import preview35 from '../../assets/ieskatam_35.jpg';
import finmerc from '../../assets/finmerc.jpg';
import preview36 from '../../assets/IMG_1139.jpg';
import preview37 from '../../assets/IMG_1053.jpg';
import preview38 from '../../assets/IMG_1109.jpg';
import preview39 from '../../assets/IMG_1147.jpg';
import preview40 from '../../assets/IMG_1113.jpg';
import preview41 from '../../assets/IMG_1162.jpg';
import preview42 from '../../assets/IMG_1103.jpg';
import preview43 from '../../assets/IMG_1153.jpg';
import preview44 from '../../assets/IMG_1160.jpg';
import preview45 from '../../assets/IMG_1165.jpg';
import preview46 from '../../assets/IMG_1166.jpg';
import preview47 from '../../assets/IMG_1122.jpg';
import preview48 from '../../assets/IMG_1177.jpg';
import preview49 from '../../assets/IMG_1188.jpg';
import preview50 from '../../assets/IMG_1195.jpg';
import preview51 from '../../assets/IMG_1198.jpg';
import preview52 from '../../assets/IMG_1209.jpg';
import preview53 from '../../assets/IMG_1210.jpg';
import x4befaft from '../../assets/x4befaft.png';
import busbefaft from '../../assets/Untitled-3.png';
import f01 from '../../assets/peccsddnoteiknt.jpg';
import IMG_2879 from '../../assets/IMG_2879.png';
import busham from '../../assets/518298163_122151609158426694_7902881398907696877_n.jpg';

const Preview = () => {
  const images = [
    x4befaft,
    f01,
    IMG_2879,
    busham,
    preview53,
    preview52,
    preview51,
    preview50,
    preview49,
    preview48,
    finmerc,
    preview46,
    preview45,
    preview44,
    preview43,
    busbefaft,
    preview42,
    preview41,
    preview40,
    preview39,
    preview38,
    preview37,
    preview36,
    preview35,
    preview2,
    preview3,
    preview4,
    preview5,
    preview6,
    preview7,
    preview8,
    preview9,
    preview10,
    preview11,
    preview12,
    preview13,
    preview14,
    preview15,
    preview16,
    preview17,
    preview18,
    preview19,
    preview20,
    preview21,
    preview22,
    preview24,
    preview25,
    preview26,
    preview27,
    preview28,
    preview29,
    preview30,
    preview31,
    preview32,
    preview33,
    preview34,
    preview1,
    preview47,
  ];

  return (
    <div className='bg-gray-900 py-12'>
      <div className='container mx-auto px-4'>
        {/* Section Title (Optional) */}
        <div className="text-center mb-12 mt-12">
          <h2 className="text-4xl font-bold mb-4 text-white">GALERIJA</h2>
          <div className="w-16 h-1 bg-green-400 mx-auto mb-6"></div>
          <p className="text-gray-300 max-w-2xl mx-auto">
            Apskati dažus no mūsu paveiktajiem darbiem!
          </p>
        </div>

        {/* Image Grid */}
        <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4'>
          {images.map((image, index) => (
            <div key={index} className='aspect-w-1 aspect-h-1'>
              <Image
                src={image}
                alt={`Preview ${index + 1}`}
                className='w-full h-full object-cover rounded-lg shadow-lg'
                preview={{
                  maskClassName: 'rounded-lg',
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Preview;